import React from 'react';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';

const ModalContainer = ({ show, onHide, content, width, height }) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" centered>
            <Modal.Header style={{ backgroundColor: '#f8f9fa', borderBottom: 'none' }}>
                <button type="button" className="close" aria-label="Close" onClick={onHide}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>{content}</Modal.Body>
        </Modal>
    );
};

export default ModalContainer;
